import React, { useState } from "react";
import HelpOutlineIcon from "@material-ui/icons/HelpOutline";
import Modal from "@material-ui/core/Modal";
import CloseIcon from "@material-ui/icons/Close";
import {trackConversion} from "../utils/analytics";
import {usePage} from "@inertiajs/inertia-react";
import {Trans} from "../utils/i18n";
import classNames from "classnames";

export default function HelpModal({ title, children, className }) {
    const [helpModal, setHelpModal] = useState(false);
    const { client, } = usePage().props;

    return (
        <>
            <div
                className="text-right cursor-pointer font-semibold text-gray-600 hover:text-black"
                onClick={() => {
                    setHelpModal(true);
                    trackConversion({
                        action: 'OrderEntrySerialNumberHelp',
                    });
                }}
            >
                <span className="inline-flex items-center mt-4">
                    {title ?? <Trans i18nKey="serialNumber.cannotFind">Can't find the serial number?</Trans>}
                    <HelpOutlineIcon className="ml-2" />
                </span>
            </div>
            {helpModal && (
                <Modal open={true} onClose={() => setHelpModal(false)} className="flex items-center justify-center">
                    <div className={classNames("bg-white w-11/12 md:max-w-xl mx-auto flex outline-none flex-wrap  relative max-h-full overflow-auto", className)}>
                        <div className="p-6 md:p-12 flex flex-col justify-center flex-1">
                            {children ?? (
                                <>
                                    {client.key !== 'bissell' && (
                                        <>
                                            <h2 className="font-semibold text-lg leading-6">
                                                <Trans i18nKey="serialNumber.whereToFindTitle">About the serial number</Trans>
                                            </h2>
                                            <p>
                                                <Trans i18nKey="serialNumber.whereToFind1">
                                                The serial number (or DSN) is a 16-digit code.
                                                </Trans>
                                                <br />
                                                <br />
                                                <Trans i18nKey="serialNumber.whereToFind2">
                                                <b>You can find the serial number</b> somewhere on your device. A detailed description of where to find it will be added later to this modal.
                                                </Trans>
                                            </p>
                                        </>
                                    )}
                                    {
                                        client.key === 'amazon' && <>
                                            <p className={'break-all'}>
                                                <Trans i18nKey="serialNumber.moreInformation">More information here:</Trans><br/>
                                                <a
                                                    className="text-blue-400 underline"
                                                    href="https://www.amazon.co.uk/hz/mycd/digital-console/alldevices"
                                                    target="_blank"
                                                    rel="noreferrer"
                                                >
                                                    https://www.amazon.co.uk/hz/mycd/digital-console/alldevices
                                                </a>
                                            </p>
                                            <p>
                                                <Trans i18nKey="serialNumber.clickTheLink">By clicking on this link you will be redirected to an external website.</Trans>
                                            </p>
                                        </>
                                    }

                                    {client.key === 'bissell' && (
                                        <>
                                            <h2 className="font-semibold text-lg leading-6 m-0">
                                                <Trans i18nKey="serialNumber.whereToFindTitle">About the serial number</Trans>
                                            </h2>
                                            <p>
                                                <Trans i18nKey="serialNumber.whereToFindText1">
                                                    <strong>On machines</strong> it’s on a white label like this. It’s usually on the lower back or bottom of the machine (for Lift-Off® models, remove the Lift-Off pod to find label) or behind the cleaning tanks.
                                                </Trans>
                                            </p>
                                            <p>
                                                <img
                                                    src="images/bissell/FINAL_LABEL.png"
                                                    alt=""
                                                    className="w-full"
                                                />
                                            </p>
                                        </>
                                    )}
                                </>
                            )}
                        </div>
                        <div
                            className={'absolute right-3 top-3 cursor-pointer text-gray-400 hover:text-gray-600'}
                            onClick={() => {
                                setHelpModal(false)
                            }}>
                            <CloseIcon/>
                        </div>
                    </div>
                </Modal>
            )}
        </>
    );
}
